module.exports = __webpack_public_path__ + "img/hr-train-wheels-shadow-3.447d6ef4.png";